import { render } from "./index.vue?vue&type=template&id=c54f0b78&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c54f0b78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c54f0b78"

export default script